import { render, staticRenderFns } from "./TimeTablePreviewArea.vue?vue&type=template&id=21808214"
import script from "./TimeTablePreviewArea.vue?vue&type=script&lang=js"
export * from "./TimeTablePreviewArea.vue?vue&type=script&lang=js"
import style0 from "./TimeTablePreviewArea.vue?vue&type=style&index=0&id=21808214&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports